export function generateJornalTicketSectionKey(objectId: string, year: number, month: number, sectionId?: number) {
  const args = Array.from(arguments);
  return args.join("_");
}

export function generateJornalRemarkSectionKey(objectId: string, sectionId: number) {
  const args = Array.from(arguments);
  return args.join("_");
}
